import { useStyles } from './styles'
import { darkTheme } from '@/shared/styles/theme/dark'

type AppRadioProps = {
  isSelected: boolean
}

export const AppRadio = (props: AppRadioProps) => {
  const { isSelected } = props
  const { classes } = useStyles()
  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: isSelected ? darkTheme.colors.button.primary.background : undefined,
        borderWidth: isSelected ? '0' : '1px',
      }}
    >
      <div
        className={classes.childCircle}
        style={{ opacity: isSelected ? 1 : 0 }}
      ></div>
    </div>
  )
}
